export class ApiUrl {
  //BaseUrl: string = "http://localhost/happyfleetzircon_api/index.php";
  BaseUrl: string = "http://zircon-api.happyfleets.com/index.php";
}
